export default __webpack_public_path__ + "static/media/bee_the_savior.5687285a.svg";